export const state = () => ({
  loading: 0,
  rightDrawer: false,
  //tenant: null,
  //accounts: [],
  //user: null,
  //roles: [],
  //account: null,
  //avatar: null,
  //logo: null,
  breadcrumbs: [],
  history: [],
  itemsPerPage: 10,
  itemsPerPageOptions: [5, 10, 25, 50, 100, -1],
  logoutMinutes: 60,
  features: [],
  assets: null,
  //permissions: [],
});
